
/**
 * 节流函数
 * scroll事件是一个高频事件，防止频繁触发造成页面卡顿
 * @param {Function} fn  要节流的函数
 * @param {number} [delay=15]
 * @param {number} [mustRun=80]
 * @returns {Function}
 */
export default function throttle(fn: Function, mustRun: number = 80): Function {
  let t_start: number | null = null;
  const _self = this;
  return function () {
    let t_current = +(new Date());
    if (!t_start) {
      t_start = t_current;

    }
    if (t_current - t_start > mustRun) {
      fn.apply(_self, ...arguments);
      t_start = t_current;
    }
  }
}
